import {
    SET_FILTER_DATA,
    SET_FILTER_VALUE,
} from 'vue/vuex/mutation-types';

/* eslint-disable camelcase */
export function setFilterData({ commit }, { items, placeholder, val, filter_query }) {
    commit(SET_FILTER_DATA, {
        items,
        placeholder,
        filterQuery: filter_query,
    });

    if (val != null) {
        commit(SET_FILTER_VALUE, { val });
    }
}
/* eslint-enable camelcase */

export function setFilterValue({ commit }, { val }) {
    commit(SET_FILTER_VALUE, { val });
}



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/dropdown-filter/actions.js